/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Api documentation
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { TenantFeaturesResp } from "./tenant-feature-api.schemas.js";

import { apiRequest } from "../context/api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const GetMyFeatures = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<TenantFeaturesResp>(
    { url: `/intl/tenant/features`, method: "GET", signal },
    options,
  );
};

export const getGetMyFeaturesQueryKey = () => {
  return [`/intl/tenant/features`] as const;
};

export const getGetMyFeaturesQueryOptions = <
  TData = Awaited<ReturnType<typeof GetMyFeatures>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof GetMyFeatures>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyFeaturesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof GetMyFeatures>>> = ({
    signal,
  }) => GetMyFeatures(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof GetMyFeatures>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyFeaturesQueryResult = NonNullable<
  Awaited<ReturnType<typeof GetMyFeatures>>
>;
export type GetMyFeaturesQueryError = unknown;

export function useGetMyFeatures<
  TData = Awaited<ReturnType<typeof GetMyFeatures>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof GetMyFeatures>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof GetMyFeatures>>,
          TError,
          Awaited<ReturnType<typeof GetMyFeatures>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyFeatures<
  TData = Awaited<ReturnType<typeof GetMyFeatures>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof GetMyFeatures>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof GetMyFeatures>>,
          TError,
          Awaited<ReturnType<typeof GetMyFeatures>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyFeatures<
  TData = Awaited<ReturnType<typeof GetMyFeatures>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof GetMyFeatures>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetMyFeatures<
  TData = Awaited<ReturnType<typeof GetMyFeatures>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof GetMyFeatures>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyFeaturesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
